import React, { useContext, useState, useEffect } from 'react';
import { VendorContext } from '../providers/Vendor.jsx';
import Collapsed from './orders/Collapsed.jsx';
import Expanded from './orders/Expanded.jsx';
import { PersonContext } from '../providers/Person.jsx';
import requests from '../utils/requests';
import Autocomplete from '../common/AutocompleteAddress.jsx';
import { s } from '../Style.jsx';
import LabeledInput from '../common/LabeledInput.jsx';

const Orders = () => {

    const { auth, newNotifications, silentNotifications } = useContext(PersonContext);
    const { vendor, filters, setFilters, orders, setOrders, gettingOrders, setGettingOrders } = useContext(VendorContext);

    const [creatingOrder, setCreatingOrder] = useState(false);
    const [viewingOrder, setViewingOrder] = useState(false);

    const [newAddress, setNewAddress] = useState("");
    useEffect(() => {
        setNewAddress("");
    }, [creatingOrder]);

    return <>

        {gettingOrders && <p><i className="fas fa-spinner fa-spin"></i></p>}

        {!gettingOrders && <>

            {!viewingOrder && !creatingOrder && <>

                <div style={s.rowTop}>
                    <button style={s.button} onClick={() => setCreatingOrder(true)}>New Delivery</button>
                </div>
                <div style={s.row}>
                    <span style={{ flex: 1 }}></span>
                </div>
                <div style={{ ...s.row, marginBottom: 10, alignItems: "center", justifyContent: "flex-end" }}>
                    <div>
                        <LabeledInput boxstyle={{ ...s.row, maxWidth: 300 }} inputstyle={{ minWidth: 160, marginBottom: 4 }} label="From" type="date" value={filters.fromDate} onChange={fromDate => setFilters({ ...filters, fromDate })} />
                        <LabeledInput boxstyle={{ ...s.row, maxWidth: 300 }} inputstyle={{ minWidth: 160 }} label="To" type="date" value={filters.toDate} onChange={toDate => setFilters({ ...filters, toDate })} />
                    </div>
                </div>

                <div style={{ ...s.row, marginBottom: 10 }}>
                    <div>
                        <h3 style={{ marginBottom: 4 }}>Deliveries</h3>
                        <span style={{ fontSize: 12 }}>from {filters.fromDate} to {filters.toDate}</span>
                    </div>
                </div>

            </>}

            {!gettingOrders && creatingOrder && <>

                <h2 style={{ marginBottom: 10 }}><s.BackArrow does={() => setCreatingOrder(false)} />New Delivery</h2>

                <div style={{ ...s.row, marginBottom: 10, alignItems: "center" }}>
                    <label>Destination</label>
                    <Autocomplete value={newAddress} onChange={address => setNewAddress(address)} />
                </div>

                <button disabled={!newAddress} style={s.button} onClick={() => {
                    setCreatingOrder(false);
                    setGettingOrders(true);
                    requests.createOrder(auth, {
                        type: "order",
                        address: newAddress,
                        vendorId: vendor.id,
                    }, () => {
                        requests.getMyVendorOrders(auth, filters).then(orders => {
                            setGettingOrders(false);
                            setOrders(orders);
                        });
                    });
                }
                }>Create</button>

            </>}

            {!creatingOrder && orders.map(order => <div key={order.id}>

                {!viewingOrder && <Collapsed setOrder={newOrder => {
                    setOrders(orders.map(o => o.id === newOrder.id ? newOrder : o));
                }} order={order} setViewingOrder={setViewingOrder} vendor={vendor} />}
                {viewingOrder?.id === order.id && <Expanded setOrders={setOrders} orders={orders} setViewingOrder={setViewingOrder} order={viewingOrder} />}

            </div>)}
        </>}
    </>;
}

export default Orders;
